import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const ShoppingBagIcon: FC<IconProps> = (props) => (
  <Icon xmlSpace="preserve" viewBox="0 0 37 42" boxSize="30px" {...props}>
    <path
      d="M33.8 40.5H3.2c-.9 0-1.7-.7-1.7-1.7V12.2c0-.9.7-1.7 1.7-1.7h30.7c.9 0 1.7.7 1.7 1.7v26.7c-.1.9-.8 1.6-1.8 1.6z"
      style={{
        fill: 'none',
        stroke: '#000',
        strokeWidth: 3,
        strokeLinecap: 'round',
        strokeLinejoin: 'bevel',
        strokeMiterlimit: 10
      }}
    />
    <path
      d="M10.5 9.5c0-4.4 3.6-8 8-8s8 3.6 8 8"
      style={{
        fill: 'none',
        stroke: '#000',
        strokeWidth: 3,
        strokeMiterlimit: 10
      }}
    />
    <path
      d="M26.5 16c0 3.6-3.6 6.5-8 6.5s-8-2.9-8-6.5"
      style={{
        fill: 'none',
        stroke: '#000',
        strokeWidth: 3,
        strokeLinecap: 'round',
        strokeMiterlimit: 10
      }}
    />
  </Icon>
)
export default ShoppingBagIcon
